import styled from 'styled-components';

import {
  Container as SemanticContainer,
  Card as SemanticCard,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent, Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled(SemanticContainer)`
  &&& {
    @media only screen and (min-width: 1200px) {
      width: 1190px;
    }

    display: flex;
    flex-direction: column;
  }

  padding-bottom: 20px;
  padding-top: 78px;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  width: 100%;
  padding: 0 5px;
`;

export const Loader = styled(LoaderLayoutComponent)`
  &&& {
    display: flex;
    flex-direction: column;
    align-self: center;
  }
`;

export const CardGroup = styled(SemanticCard.Group)`
  &&& {
    margin: 11.5px 5px 0 5px;
    padding: 0px;
  }
`;

export const Message = styled(TextLayoutComponent)`
  margin-bottom: 40px;
  max-width: 600px;
  font-size: 18px;
  text-align: center;
`;

export const CreateButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    font-size: 14px;
  }
`;
